import React from 'react';
import styled from './styled';

interface RowTitleProps {
  title: string;
}

const RowTitle = ({ title }: RowTitleProps) => (
  <Container>
    {title ? <Title>{title}</Title> : <Placeholder>No information</Placeholder>}
  </Container>
);

export default RowTitle;

const Container = styled.View`
  flex: 1;
  flex-direction: row;
  padding-horizontal: 20px;
`;

const Title = styled.Text`
  font-size: 18px;
  margin-right: 20px;
  flex: 1;
`;

const Placeholder = styled.Text`
  font-size: 18px;
  flex: 1;
  opacity: 0.5;
  font-style: italic;
  margin-right: 20px;
`;
